<mat-dialog-content
    cdkDrag
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    cdkDragRootElement=".cdk-overlay-pane"
    class="pip-call-dialog__content"
>
    <div class="pip-call-dialog__tile">
        <video
            #remoteVideo
            [autoplay]="true"
            [loop]="true"
            [volume]="volume / 10"
            class="pip-call-dialog__video"
        ></video>

        <div *ngIf="remoteParticipantName" class="pip-call-dialog__tile-name">{{ remoteParticipantName }}</div>

        <div *ngIf="hasCallPartner && remoteVideoDisabled" class="pip-call-dialog__tile-off">
            <mat-icon>videocam_off</mat-icon>
        </div>

        <div *ngIf="!hasCallPartner" class="pip-call-dialog__tile-off">
            <mat-icon>phone_disabled</mat-icon>
        </div>

        <div *ngIf="hasCallPartner && remoteAudioDisabled" class="pip-call-dialog__tile-mic">
            <mat-icon>mic_off</mat-icon>
        </div>
    </div>

    <div class="pip-call-dialog__tile">
        <video #localVideo [autoplay]="true" [loop]="true" [muted]="true" class="pip-call-dialog__video"></video>

        <div *ngIf="localParticipantName" class="pip-call-dialog__tile-name">{{ localParticipantName }}</div>

        <div *ngIf="!videoEnabled" class="pip-call-dialog__tile-off">
            <mat-icon>videocam_off</mat-icon>
        </div>

        <div *ngIf="!microphoneEnabled" class="pip-call-dialog__tile-mic">
            <mat-icon>mic_off</mat-icon>
        </div>
    </div>

    <div class="pip-call-dialog__volume">
        <button
            mat-icon-button
            type="button"
            class="pip-call-dialog__volume-button"
            [disabled]="volume <= 0"
            (click)="changeVolume(-1)"
        >
            <mat-icon>volume_down</mat-icon>
        </button>
        <input
            type="range"
            class="pip-call-dialog__volume-slider"
            max="10"
            min="0"
            step="1"
            [(ngModel)]="volume"
            (ngModelChange)="saveVolume()"
            aria-label="volume"
        />
        <button
            mat-icon-button
            type="button"
            class="pip-call-dialog__volume-button"
            [disabled]="volume >= 10"
            (click)="changeVolume(1)"
        >
            <mat-icon>volume_up</mat-icon>
        </button>
    </div>

    <div class="pip-call-dialog__actions">
        <button
            (click)="toggleMicrophone()"
            [color]="microphoneEnabled ? 'primary' : 'accent'"
            mat-mini-fab
            type="button"
        >
            <mat-icon *ngIf="microphoneEnabled">mic</mat-icon>
            <mat-icon *ngIf="!microphoneEnabled">mic_off</mat-icon>
        </button>

        <button (click)="toggleVideo()" [color]="videoEnabled ? 'primary' : 'accent'" mat-mini-fab type="button">
            <mat-icon *ngIf="videoEnabled">videocam</mat-icon>
            <mat-icon *ngIf="!videoEnabled">videocam_off</mat-icon>
        </button>

        <button
            (click)="fullscreen()"
            [color]="'primary'"
            class="pip-call-dialog__fullscreen"
            mat-mini-fab
            type="button"
        >
            <mat-icon>aspect_ratio</mat-icon>
        </button>

        <button (click)="startScreenCapture()" *ngIf="!isScreenCapture" [color]="'primary'" mat-mini-fab type="button">
            <mat-icon>cast</mat-icon>
        </button>

        <button (click)="stopScreenCapture()" *ngIf="isScreenCapture" [color]="'accent'" mat-mini-fab type="button">
            <mat-icon>cast_connected</mat-icon>
        </button>

        <button (click)="hangUp()" [color]="'warn'" class="pip-call-dialog__hang-up" mat-mini-fab type="button">
            <mat-icon>call_end</mat-icon>
        </button>
    </div>
</mat-dialog-content>
